import { useIntl } from 'react-intl';
import { IconCustomMailGroup, IconMail } from '@rossum/ui/icons/tabler';
import { Badge, Stack, SvgIcon, Tooltip } from '@rossum/ui/material';

type Props = {
  onClick: () => void;
  hasReplies: boolean;
  hasNewReplies: boolean;
  dataCy?: string;
};

export const EmailBadge = ({
  onClick,
  hasReplies,
  hasNewReplies,
  dataCy,
}: Props) => {
  const intl = useIntl();

  const tooltipId = hasNewReplies
    ? 'components.email.tooltipWithNewReplies'
    : hasReplies
      ? 'components.email.tooltipWithReplies'
      : 'components.email.tooltipOther';

  return (
    <Stack
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      sx={{ cursor: 'pointer' }}
      data-cy={dataCy}
    >
      <Tooltip title={intl.formatMessage({ id: tooltipId })} placement="top">
        <Badge
          variant="dot"
          color="info"
          invisible={!hasNewReplies}
          data-cy={hasNewReplies ? 'blue-kulicka' : 'without-blue-kulicka'}
        >
          <SvgIcon fontSize="medium">
            {hasReplies ? <IconCustomMailGroup /> : <IconMail />}
          </SvgIcon>
        </Badge>
      </Tooltip>
    </Stack>
  );
};
